// extracted by mini-css-extract-plugin
export default {"swiggle":"Step_swiggle__MLE4b","icon":"Step_icon__dij6X","text":"Step_text__uorIN","rows":"Step_rows__Rdodz"};